import { z } from 'zod';
/**
 * ehr-credify role model (README §9). The SSO token carries NO role — these are
 * resolved from the local `users` row after identity mapping. This is the single
 * source of truth for the prototype's `getRoleKey()` seam.
 */
export const ROLES = [
    'admin',
    'manager',
    'clinician',
    'supervisor',
    'front_desk',
];
export const roleSchema = z.enum(ROLES);
/** Roles with org-wide rule-management authority (README §9 role tiers). */
export const RULE_MANAGER_ROLES = ['admin', 'manager'];
/** Roles whose sign-off queue is scoped to their own tasks only. */
export const SELF_SCOPED_SIGNOFF_ROLES = ['clinician', 'supervisor'];
export function canManageRules(role) {
    return RULE_MANAGER_ROLES.includes(role);
}
//# sourceMappingURL=roles.js.map